import React from 'react';
import _ from 'lodash';
// import { DateTimePicker, DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import DateInput, { dateToFormattedString, getFormat } from '../../forms/DateInput';
// import * as Convert from '../../utils/convert';
import { fieldFormat } from '../../utils/helper';
import PropTypes from 'prop-types';

/**
 * Edit datetime cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export function EditDateTimeCell({ getColumns }) {
  class EditDateTimeCell extends React.Component {
    timeout = null;

    constructor(props) {
      super(props);

      const { field, dataItem } = props;
      const dataValue = _.get(dataItem, field.split('.'));

      this.state = {
        value: dataValue,
      }
    }

    handleChange = (e) => {
      const { field, dataItem, onChange } = this.props;

      this.setState({ value: e.target.value });

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(() => {
        onChange({
          dataItem: dataItem,
          field: field,
          syntheticEvent: e.syntheticEvent,
          value: this.state.value
        });

        this.timeout = null;
      }, 1000);
    }

    handleInputChange = (name, value) => {
      const { field, dataItem, onChange } = this.props;

      this.setState({ value: value });

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(() => {
        onChange({
          dataItem: dataItem,
          field: field,
          syntheticEvent: new Event('change'),
          value: this.state.value
        });

        this.timeout = null;
      }, 1000);
    }

    componentDidUpdate(prevProps, prevState) {
      const { field, dataItem } = this.props;
      const dataValue = _.get(dataItem, field.split('.'));
      const prevDataValue = _.get(prevProps.dataItem, prevProps.field.split('.'));
      if (prevDataValue !== dataValue) {
        this.setState({ value: dataValue });
      }
    }

    buildInput = (column, dataValue, format) => {
      return (
        <DateInput
          type={column.filter.replace('input', '')}
          onChange={this.handleInputChange}
          value={dataValue}
          format={format}
          name={column.field}
          todayHidden={true}
          validationHidden={true}
        />
      );
      // switch (column.filter) {
      //   case 'time':
      //     return (<TimePicker
      //       onChange={this.handleChange}
      //       value={dataValue}
      //       format={format}
      //     />);
      //   case 'date':
      //     return (<DatePicker
      //       onChange={this.handleChange}
      //       value={dataValue}
      //       format={format}
      //     />);
      //   case 'datetime':
      //     return (<DateTimePicker
      //       onChange={this.handleChange}
      //       value={dataValue}
      //       format={format}
      //     />);
      //   default:
      //     return (
      //       <DateInput
      //         type={column.filter.replace('input', '')}
      //         onChange={this.handleInputChange}
      //         value={dataValue}
      //         format={format}
      //         name={column.field}
      //         todayHidden={true}
      //         validationHidden={true}
      //       />
      //     );
      // }
    }

    render() {
      const { dataItem, field } = this.props;
      const column = getColumns().find(item => item.field === field);
      const format = this.props.format ? getFormat({ format: fieldFormat(this.props.format), type: column.filter.replace('input', '') }) :
        (column.filter === 'time' ? "HH:mm" :
          column.filter === 'date' ? "dd.MM.yy" :
            "dd.MM.yy H:m");
      const dataValue = this.state.value;
      const className = (dataItem.inEdit ? "k-grid-edit-cell " : "") + this.props.className;

      const td = (
        <td colSpan={this.props.colSpan}
          className={className}
          style={this.props.style}
          role="gridcell"
          aria-colindex={(this.props.columnIndex || 0) - (this.props.level || 0) + 1}
          aria-selected={false}
          tabIndex="0">
          {((dataItem.inEdit === true || dataItem.inEdit === this.props.field) && column.editable !== false) ? (
            this.buildInput(column, dataValue, format)
          ) : (
            // Convert.dateToStr(dataValue, format)
            dateToFormattedString(dataValue, column.filter.replace('input', ''), format)
          )}
        </td>
      );
      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }

  EditDateTimeCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func
  }

  return EditDateTimeCell
}